import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoleDetailsModel, RoleModel, RoleSaveModel, SearchModel, SearchResultModel } from 'src/common';
import { environment } from 'src/environments/environment';

const localApiUrl = `${environment.apiUrl}/Roles`;

@Injectable()
export class RolesService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<any>> {
    return this.http.post<SearchResultModel<any>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<RoleModel[]> {
    return this.http.get<RoleModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<RoleDetailsModel> {
    return this.http.get<RoleDetailsModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
    return this.http.get<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: RoleSaveModel): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }
}
